module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Bold-f3912ea7c412192d2f355bd68f0d76f4.woff2";